import { useState } from "react";

import { useRobotControl } from "providers/RobotControlProvider";
import { useDockedActionGate } from "lib/hooks/useDockedActionGate";

import FunctionalButton from "components/layout/FunctionalButton";

import { RobotModeIcons } from "lib/consts/robot";

const fallbackIcon = RobotModeIcons.WALK || RobotModeIcons.SIT;

const modeIcon = (name) => RobotModeIcons[name] || fallbackIcon;

/** Modes that would stand the robot up / leave sit while on the charger. */
const isStandOrWalkMode = (mode) => {
    const m = String(mode || "").trim().toUpperCase();
    return m === "WALK" || m === "STAND" || m === "STANDARD" || m === "CRAWL" || m === "STAIR";
};

const ModeBar = ({ className = "" }) => {
    const [showModes, setShowModes] = useState(false);

    const { enableControl, modes, mode, sendMode } = useRobotControl();
    const { runWithDockedGate, dockedGateModal } = useDockedActionGate();

    const safeMode =
        typeof mode === "string" && mode.trim() ? mode.trim().toUpperCase() : "SIT";
    const modeList = (Array.isArray(modes) ? modes : [])
        .filter((m) => typeof m === "string" && m.trim())
        .map((m) => m.trim().toUpperCase());

    const buttonClass = (active) =>
        `control-button-type3 shrink-0 text-white ${active ? "control-button-active" : ""}`;

    const requestMode = (nextMode) => {
        const apply = () => {
            sendMode(nextMode);
            setShowModes(false);
        };
        if (isStandOrWalkMode(nextMode) && nextMode !== safeMode) {
            runWithDockedGate(apply);
            setShowModes(false);
            return;
        }
        apply();
    };

    return (
        <>
            <div className={`flex items-center space-x-2 ${className}`}>
                {enableControl && showModes ? (
                    modeList.map((m) => (
                        <FunctionalButton
                            key={m}
                            icon={modeIcon(m)}
                            hoverText={m}
                            className={buttonClass(m === safeMode)}
                            onClick={() => requestMode(m)}
                        />
                    ))
                ) : (
                    <FunctionalButton
                        icon={modeIcon(safeMode)}
                        hoverText={safeMode}
                        className={buttonClass(true)}
                        onClick={() => setShowModes(true)}
                        disabled={!enableControl}
                    />
                )}
            </div>
            {dockedGateModal}
        </>
    );
};

export default ModeBar;
